import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseRank'
})
export class ParseRankPipe implements PipeTransform {

  transform(value: {rank:number, rankOld:number}, args?: any): any {
    return this.parseRank(value.rank, value.rankOld);
  }
  parseRank(rank: number, rankOld: number): string {
    let number = 0;

    if (rank > rankOld) {
      number = rank - rankOld;
    }
    if (rank < rankOld) {
      number = rankOld - rank;
    }
    if (rank === rankOld) {
      return '';
    }
    return rank < rankOld
      ? '+'.concat(number.toString())
      : '-'.concat(number.toString());
  }
  
}
